export default __webpack_public_path__ + "static/content-b1e68f8c31fb6c13b52222ce510c8b71.jpg";